import { render, staticRenderFns } from "./Infoboks.vue?vue&type=template&id=71d5c3a6&"
import script from "./Infoboks.vue?vue&type=script&lang=js&"
export * from "./Infoboks.vue?vue&type=script&lang=js&"
import style0 from "./Infoboks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports